import React from 'react';

const TextInput = ({
  name,
  label,
  type,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled,
  error,
  touched,
  style,
  required = true,
  className,
  maxLength,
  overFlow,
  length,
  additionalContent,
}) => {
  const safeValue = value === null ? '' : value;
  const InputComponent = type === 'textarea' ? 'textarea' : 'input';

  return (
    <div className="form-field-container">
      <div className="input-section-container">
        {label && (
          <div className="form-label-container">
            <>
              <h5 htmlFor={name} className="form-label">
                {label}
              </h5>
              {required && <span style={{ color: 'red' }}> *</span>}
            </>
          </div>
        )}
        <div className="col-container">
          <div className={className || 'col-md-12'}>
            <div className={`input-group`} style={{ position: 'relative' }}>
              <InputComponent
                type={type === 'textarea' ? 'text' : type}
                name={name}
                className={`form-control ${
                  overFlow && maxLength ? 'overflow' : ''
                }`}
                value={safeValue}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                style={style}
                disabled={disabled}
              />
              {maxLength && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '10px',
                    fontSize: '12px',
                  }}
                >
                  {length} / {maxLength}
                </span>
              )}
            </div>
          </div>
          {error && touched && <div className="error">{error}</div>}
        </div>
      </div>
      {additionalContent}
    </div>
  );
};

export default TextInput;
